export const SCHOOL_COLUMN = 'SCHOOL_COLUMN';
export const SCHOOL_INDEX = 'SCHOOL_INDEX';
export const SCHOOL_LOADING_INDEX = 'SCHOOL_LOADING_INDEX';
export const SCHOOL_LOADING_SHOW = 'SCHOOL_LOADING_SHOW';
export const SCHOOL_OPTION = 'SCHOOL_OPTION';
export const SCHOOL_RESET = 'SCHOOL_RESET';
export const SCHOOL_SEARCH = 'SCHOOL_SEARCH';
export const SCHOOL_SHOW = 'SCHOOL_SHOW';
